
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.685 5.79h8.602l-1.242-1.493.508-.43 3.82 3.82v.5l-3.82 3.82-.508-.429 1.258-1.508H3.678l1.257 1.508-.507.43-3.82-3.82v-.5l3.82-3.82.507.429-1.25 1.492zm9.407 1.038H2.889l-.899 1.11.883 1.093h10.226l.891-1.094-.898-1.109z","fill":"#748190"}})])
          )
        }
      }
    